export default class CareComponentsModule {
    provides() {
        return {
            CareRoutes: [() => require('./routes').default],
        };
    }
}
